import http from 'hub-http/clients/apiClient';
import { registerQuery, useQuery } from 'data-fetching-client';
import { reportError } from 'automation-ui-core/errors/utils/reportError';
import Flow from 'automation-ui-canvas/flow/records/Flow/Flow';
import { jsx as _jsx } from "react/jsx-runtime";
/*******************************************************
 ************************ GET **************************
 *******************************************************/

export const TEMPLATE_BY_ID_FIELDNAME = 'templateById';
export const GET_TEMPLATE_BY_ID = registerQuery({
  fieldName: TEMPLATE_BY_ID_FIELDNAME,
  args: ['templateId'],
  fetcher({
    templateId
  }) {
    return http.get(`automation-templates/v1/template-library/${templateId}`).catch(error => {
      const errorWithInfo = error;
      reportError({
        error: errorWithInfo,
        tags: {}
      });
      throw error;
    });
  }
});
export const useGetTemplateById = ({
  templateId
}) => {
  const query = useQuery(GET_TEMPLATE_BY_ID, {
    variables: {
      templateId: templateId
    },
    skip: !templateId
  });
  return query;
};
export const wireTemplate = WrappedComponent => props => {
  const {
    flow
  } = props;
  if (flow && flow instanceof Flow) {
    const templateId = flow.getTemplateId();
    if (templateId) {
      const {
        data
      } = useGetTemplateById({
        templateId
      });
      const template = data === null || data === void 0 ? void 0 : data.templateById;
      if (template) {
        return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props, {
          template: template
        }));
      }
    }
  }
  return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props));
};